import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ContactModel, ContactPickerModalComponent } from '@boxx/contacts-core';
import { EventModel, EventsStore } from '@boxx/events-core';
import { LocationPickerComponent } from '@boxx/shared-components';
import { DatetimePickerComponent } from '@boxx/shared-components/lib/datetime-picker/datetime-picker.component';
import { ActionSheetController, IonModal, ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { format, parseISO } from 'date-fns';
import { CustomDatetimePickerComponent } from '@boxx/shared-components/lib/custom-datetime-picker/custom-datetime-picker.component';


@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'boxx-event-form',
  templateUrl: './event-form.component.html',
  styleUrls: ['./event-form.component.scss'],
})
export class EventFormComponent implements OnInit, OnDestroy {
  @ViewChild('modalOne') modalOne!: ModalController;
  @ViewChild('modalTwo') modalTwo!: ModalController;
  yearValues = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];
  @Input() set event(payload: EventModel) {
    if (!payload) {
      return;
    }

    this.myEvent = payload;
    this.originalValues = EventModel.clone(payload);
    this.setEvent();

    setTimeout(() => {
      this.boxxChange.emit({
        hasChanges: false,
        valid: this.eventForm.valid,
        data: payload,
      });
    }, 800);
  }
  minInsterval: number[];
  get event() {
    return this.myEvent;
  }

  @Output() boxxChange = new EventEmitter<IEventDetailEmitter>();

  @Input() showLoader = true;

  destroyed$ = new Subject<boolean>();
  monthNames = moment.months().toString();
  translations: any = {};

  evAttendees: ContactModel[] = [];
  eventForm: FormGroup;

  private myEvent: EventModel = EventModel.empty();
  private originalValues: EventModel;

  isModalOpenOne = false;
  isModalOpenTwo = false;
  isModalOpenThree = false;
  isModalOpenFour = false;

  modalType = 1;
  modalTypeTwo = 1;

  constructor(
    public actionSheetCtrl: ActionSheetController,
    private translate: TranslateService,
    private fb: FormBuilder,
    private boxxUtils: BoxxUtilsService,
    private modalCtrl: ModalController,
    private eventsStore: EventsStore,
    private viewCtrl: ModalController
  ) {}

  ngOnInit() {
    this.translate
      .get(['EVENTS_MODULE', 'FORMS', 'ACTIONS', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    this.handleLoading();

    const minT = 0,
      maxT = 55,
      interval = 5;

    const length = (maxT - minT) / interval + 1;
    this.minInsterval = Array.from({ length }, (_, i) => minT + i * interval);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
    this.boxxUtils.handleLoading(false);
  }

  setEvent() {
    console.log('this.event: ', this.event);
    this.evAttendees = [...this.event.attendees];
    this.eventForm = this.fb.group({
      id: [this.event.id],
      title: [this.event.title, Validators.required],
      url: [this.event.url],
      description: [this.event.description],
      place: [this.event.place],
      datetimeFromFormat: [
        this.formatDate(moment(this.event.datetimeFrom).format()),
        Validators.required,
      ],
    datetimeToFormat: [
        this.formatDate(moment(this.event.datetimeTo).format()),
        Validators.required,
      ],
    // datetimeFrom: [
    //   this.formatDate(moment(this.event.datetimeFrom).format()),
    //   Validators.required,
    // ],
    datetimeFrom: moment(this.event.datetimeFrom).format(),
    // datetimeTo: [this.formatDate(moment(this.event.datetimeTo).format())],
    datetimeTo: moment(this.event.datetimeTo).format(),
      // datetimeFromFormat: (this.event.id === null) ? this.setDefaultCurrentDateTime() : [
      //     this.formatDate(moment(this.event.datetimeFrom).format()),
      //     Validators.required,
      //   ],
      // datetimeToFormat: (this.event.id === null) ? this.setDefaultCurrentDateTime() : [
      //     this.formatDate(moment(this.event.datetimeTo).format()),
      //     Validators.required,
      //   ],
      // datetimeFrom: (this.event.id === null) ? this.setDefaultCurrentDateTimeFormat() : moment(this.event.datetimeFrom).format(),
      // datetimeTo: (this.event.id === null) ? this.setDefaultCurrentDateTimeFormat() : moment(this.event.datetimeTo).format(),
      attendees: [this.evAttendees || []],
      latitude: [this.event?.latitude],
      longitude: [this.event?.longitude],
    });
    if(this.event.id !== null){
      this.setDefaultEndDateTime();
    }

  }

  formatDate(originalDate){
    return format(parseISO(originalDate), 'dd MMMM yyyy - HH:mm');
  }

  setDefaultCurrentDateTime(){
    let currentTime = moment(new Date()).format();
    let splitDateTime = currentTime.split('T');
    let coeff = 1000 * 60 * 5;
    let date = new Date();  //or use any other date
    let rounded = new Date(Math.round(date.getTime() / coeff) * coeff);

    let formatTime = ("0" + rounded.getHours()).slice(-2)   + ":" + 
    ("0" + rounded.getMinutes()).slice(-2) + ":" + 
    ("0" + rounded.getSeconds()).slice(-2);
    const finalDate = splitDateTime[0] + 'T' + formatTime + '-00:00';

    const finalFormatDate = moment(finalDate);
    const formatReturnDate = this.formatDate(finalFormatDate.add(0, 'hours').format());
    let fformat = moment(finalDate).format('');
    return fformat;
  }

  setDefaultCurrentDateTimeFormat(){
    let currentTime = moment(new Date()).format();
    let splitDateTime = currentTime.split('T');
    let coeff = 1000 * 60 * 5;
    let date = new Date();  //or use any other date
    let rounded = new Date(Math.round(date.getTime() / coeff) * coeff);

    let formatTime = ("0" + rounded.getHours()).slice(-2)   + ":" + 
    ("0" + rounded.getMinutes()).slice(-2) + ":" + 
    ("0" + rounded.getSeconds()).slice(-2);
    const finalDate = splitDateTime[0] + 'T' + formatTime + '-00:00';

    const finalFormatDate = moment(finalDate).format('dd MMMM yyyy - HH:mm');
    return finalFormatDate;
  }

  setDefaultEndDateTime(){
    const currentEndDate = moment(this.eventForm.value.datetimeTo);
    const currentEndDateF = moment(this.eventForm.value.datetimeToFormat);
    this.eventForm.patchValue({
      datetimeTo: currentEndDate.subtract(1, 'hours').format(),
      datetimeToFormat: this.formatDate(currentEndDate.add(1, 'hours').format()),
    });
    //console.log('setDefaultEndDateTime bien:', this.formatDate(currentEndDate.add(1, 'hours').format()));
  }

  async openContactPicker() {
    const modal = await this.modalCtrl.create({
      component: ContactPickerModalComponent,
      componentProps: {
        currentAttendees: this.evAttendees.map((c) => c.id),
      },
      backdropDismiss: false,
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();

    if (data) {
      this.eventForm.patchValue({ attendees: [...data] });
      this.evAttendees = [...data];
      this.onControlChange();
    }
  }

  async removeAttendee(contact: ContactModel) {
    this.translate
      .get('EVENTS_MODULE.removeAttendee_ALERT.message', {
        name: `${contact.name} ${contact.lastName}`,
      })
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (msg) => {
        this.boxxUtils.showAlert({
          header: this.translations.EVENTS_MODULE.removeAttendee_ALERT.header,
          message: msg,
          buttons: [
            {
              text: this.translations.ACTIONS.cancel,
              role: 'cancel',
              cssClass: 'boxx-main-btn',
            },
            {
              text: this.translations.ACTIONS.ok,
              handler: () => {
                this.evAttendees = this.evAttendees.filter(
                  (c) => c.id !== contact.id
                );
                this.eventForm.patchValue({
                  attendees: this.evAttendees,
                });
                this.onControlChange();
              },
            },
          ],
        });
      });
  }

  async showAttendeeDetails(contact: ContactModel) {
 
    const message =
      (contact.email ? `<b>Email</b>: ${contact.email}<br>` : '') +
      (contact.phone
        ? `<b>${this.translations.FORMS.phone}</b>: ${contact.phone}`
        : '');

    this.boxxUtils.showAlert({
      header: `${contact.name} ${contact.lastName}`,
      message,
      buttons: [
        {
          text: this.translations.ACTIONS.cancel,
        },
      ],
    });
  }

  async openSearchPlace() {
    const modal = await this.modalCtrl.create({
      component: LocationPickerComponent,
      // componentProps: {}
    });

    await modal.present();

    const { data } = await modal.onWillDismiss();

    if (data) {
      this.eventForm.patchValue({ place: data.description });
      this.onControlChange();
    }
  }

  removeLocation() {
    this.eventForm.patchValue({
      place: '',
    });
  }

  dateChange(value, isStart = true) {
    const currentStartDate = moment(this.eventForm.value.datetimeFromFormat);
    const currentEndDate = moment(this.eventForm.value.datetimeToformat);
    if (isStart) {
      const startValue = moment(value);
      if (startValue >= currentEndDate) {
        this.eventForm.patchValue({
          datetimeTo: currentEndDate.subtract(1, 'hours').format(),
          datetimeToFormat: this.formatDate(currentStartDate.add(1, 'hours').format()),
        });
      }
    } else {
      const endValue = moment(value);
      if (endValue <= currentStartDate) {
        this.eventForm.patchValue({
          datetimeTo: currentEndDate.subtract(1, 'hours').format(),
          datetimeToFormat: this.formatDate(currentEndDate.subtract(1, 'hours').format()),
        });
      }
    }

    this.onControlChange();
  }

  onControlChange() {
    const formValues = this.eventForm.value as EventModel;

    const hasChanges = Object.keys(formValues).some((key) => {
      if (key === 'attendees') {
        const originalAttendees = [...this.originalValues[key]];
        if (originalAttendees.length !== formValues[key].length) {
          return true;
        }

        originalAttendees.sort((a, b) => a.id - b.id);

        const attendeesChanged = originalAttendees.some(
          (contact, idx) => contact.id !== formValues.attendees[idx].id
        );

        /* if (attendeesChanged) {
        } */

        return attendeesChanged;
      }

      if (['datetimeFrom', 'datetimeTo'].includes(key)) {
        const newDate = moment(formValues[key]);
        const oldDate = moment(this.originalValues[key]);
        const dateChanged = !newDate.isSame(oldDate);

        /* if (dateChanged) {

        } */

        return dateChanged;
      }

      const otherChanges = this.originalValues[key] !== formValues[key];

      /* if (otherChanges) {
        console.log(
          '--- otherChanges',
          key,
          this.originalValues[key],
          formValues[key]
        );
      } */

      return otherChanges;
    });

    this.boxxChange.emit({
      hasChanges,
      valid: this.eventForm.valid,
      data: EventModel.clone(formValues),
    });
  }

  private handleLoading() {
    this.eventsStore.loading$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((loading) => {
        if (this.showLoader) {
          this.boxxUtils.handleLoading(loading);
        }
      });
  }

  async pickerDatetime(typeInput: Number){
    const ctrls = this.eventForm.value;
    const view = await this.viewCtrl.create({
      component: CustomDatetimePickerComponent,
      componentProps: {
        customDate: (typeInput === 1) ? ctrls.datetimeFrom : ctrls.datetimeTo
      }
    });

    await view.present();

    const { data } = await view.onWillDismiss();

    if (data) {
        //this.dateChange(data.cDate, (typeInput === 1) ? true : false);
        if(typeInput === 1){
          const selDate = moment(data.cDate).add(60, 'minutes').format();
          const newEndDate = moment(data.cDate).add(120, 'minutes').format();
          this.eventForm.patchValue(
          { 
            datetimeFrom: data.cDate,
            datetimeFromFormat: this.formatDate(selDate),

            datetimeTo: newEndDate,
            datetimeToFormat: this.formatDate(newEndDate),
          });
        }
        else{
          const selDate = moment(data.cDate).add(60, 'minutes').format();
          this.eventForm.patchValue(
          { 
            datetimeTo: data.cDate,
            datetimeToFormat: this.formatDate(selDate),
          });
        }
        this.onControlChange();
    }
  }

  // setOpen(isOpen: boolean, modalSelect: number) {
  //   console.log('open: ', isOpen);
  //   console.log('modalSelect: ', modalSelect);
  //   if(modalSelect === 1){
  //     this.isModalOpenOne = isOpen;
  //   }
  //   else{
  //     this.zone.run(() => {
  //       this.isModalOpenThree = isOpen;
  //       console.log('this.isModalOpenThree: ', this.isModalOpenThree);
  //       this.cd.detectChanges();
  //     });
  //   }
  // }

  // openTwo(modalSelect: number){
  //   if(modalSelect === 1){
  //     this.isModalOpenOne = false;
  //     this.isModalOpenTwo = true;
  //   }
  //   else{
  //     this.isModalOpenThree = false;
  //     this.isModalOpenFour = true;
  //   }
  // }

  // setOpenTwo(isOpen: boolean, modalSelect: number) {
  //   if(modalSelect === 1){
  //     this.isModalOpenTwo = isOpen;
  //   }
  //   else{
  //     this.isModalOpenThree = isOpen;
  //   }
  // }

  // selectDate(modalSelect: number){
  //   if(modalSelect === 1){
  //     this.eventForm.patchValue(
  //       { 
  //         datetimeFrom: this.event.datetimeFrom,
  //         datetimeFromFormat: this.formatDate(this.event.datetimeFrom),
  //       });
  //       this.modalOne.dismiss();
  //       console.log('cerre');
  //       this.isModalOpenFour = true;
  //   }
  //   else{
  //     this.eventForm.patchValue(
  //       { 
  //         datetimeFrom: this.event.datetimeFrom,
  //         datetimeFromFormat: this.formatDate(this.event.datetimeFrom),
  //       });
  //       this.isModalOpenFour = false;
  //   }


  // }


  setOpen(){
    this.modalType = 1;
  }

  openTwo(modalSelect: number){
    this.modalType = modalSelect;
    let mDate = this.event.datetimeFrom.replace('T', ' ');
    this.eventForm.patchValue(
      { 
        datetimeFrom: mDate.slice(0, 19),
        datetimeFromFormat: this.formatDate(this.event.datetimeFrom),
      });
  }

  closeModal(){
    this.modalCtrl.dismiss();
  }

  selectDate(){
    let mDate = this.event.datetimeFrom.replace('T', ' ');
    this.eventForm.patchValue(
      { 
        datetimeFrom: mDate.slice(0, 19),
        datetimeFromFormat: this.formatDate(this.event.datetimeFrom),
      });
    this.modalCtrl.dismiss();
    this.modalType = 1;

    const currentEndDate = moment(this.eventForm.value.datetimeFrom);
    const nextDate = this.formatDate(currentEndDate.add(1, 'hours').format());

    let tDate = currentEndDate.format().replace('T', ' ');
    this.eventForm.patchValue({
      datetimeTo: tDate.slice(0, 19),
      datetimeToFormat: nextDate,
    });

  }

  //Modal two
  setOpenTwo(){
    this.modalTypeTwo = 1;
  }

  openTwoTo(modalSelect: number){
    this.modalTypeTwo = modalSelect;
    let mDate = this.event.datetimeTo.replace('T', ' ');
    this.eventForm.patchValue(
      { 
        datetimeTo: mDate.slice(0, 19),
        datetimeToFormat: this.formatDate(this.event.datetimeTo),
      });
  }

  selectDateTwo(){
    let mDate = this.event.datetimeTo.replace('T', ' ');
    this.eventForm.patchValue(
      { 
        datetimeTo: mDate.slice(0, 19),
        datetimeToFormat: this.formatDate(this.event.datetimeTo),
      });
    this.modalCtrl.dismiss();
    this.modalTypeTwo = 1;
  }

}

export interface IEventDetailEmitter {
  hasChanges: boolean;
  valid: boolean;
  data: EventModel;
}
